import axios from "axios/index";
import { API } from "../utilities/api.config";

function getHouseholdById(id) {
  return (dispatch) => {
    dispatch({ type: "HOUSEHOLD_DETAIL_REQUESTED" });
    return axios
      .get(`${API.GET_HOUSEHOLD_BY_ID}/${id}`, {
        headers: { Authorization: localStorage.getItem("wbiAuthToken") },
      })
      .then((response) => {
        const payload = response.data;
        dispatch({
          type: "HOUSEHOLD_DETAIL_SUCCESS",
          payload,
        });
        return payload;
      })
      .catch((error) => {
        dispatch({
          type: "HOUSEHOLD_DETAIL_FAIL",
          payload: error,
        });
        if (error.response.status === 401) {
          dispatch({
            type: "LOGOUT",
          });
        }
      });
  };
}

function removeHouseholdById(id) {
  return (dispatch) => {
    dispatch({ type: "REMOVE_HOUSEHOLD_REQUESTED" });
    return axios
      .delete(`${API.DELETE_HOUSEHOLD_BY_ID}/${id}`, {
        headers: { Authorization: localStorage.getItem("wbiAuthToken") },
      })
      .then((response) => {
        const payload = response.data;
        dispatch({
          type: "REMOVE_HOUSEHOLD_SUCCESS",
          payload,
        });
        return payload;
      })
      .catch((error) => {
        dispatch({
          type: "REMOVE_HOUSEHOLD_FAIL",
          payload: error,
        });
      });
  };
}

function clearMessage() {
  return (dispatch) => {
    dispatch({
      type: "CLEAR_MESSAGE",
    });
  };
}

function saveHouseholdMetadata(householdId, data) {
  return (dispatch) => {
    dispatch({
      type: "HOUSEHOLD_SAVE_META_REQUESTED",
    });
    axios
      .patch(`${API.SAVE_HOUSEHOLD_META}/${householdId}/meta`, data, {
        headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
      })
      .then((response) => {
        dispatch({
          type: "HOUSEHOLD_SAVE_META_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "HOUSEHOLD_SAVE_META_FAIL",
          payload: error,
        });
        if (error.response.status === 401) {
          dispatch({
            type: "LOGOUT",
          });
        }
      });
  };
}

function clearCurrentHousehold() {
  return (dispatch) => {
    dispatch({
      type: "CLEAR_CURRENT_HOUSEHOLD",
    });
  };
}

function updateHouseholdSettings(householdSettings) {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_HOUSEHOLD_SETTING",
      payload: householdSettings,
    });
  };
}

export const householdAction = {
  getHouseholdById,
  removeHouseholdById,
  clearMessage,
  clearCurrentHousehold,
  saveHouseholdMetadata,
  updateHouseholdSettings,
};

export default householdAction;



// WEBPACK FOOTER //
// ./src/actions/household.action.js